<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div class="eDetailElement col-12 col-md-12">
      <strong>New Equipment Registration</strong>
      <div class="invoiceBox" style="margin-left: 0; width: 95%;">
        <div style="margin-top: 2%;" id="totalCostDisplay">
          <strong id="smbCost" style="margin-left: 4%; position: relative; bottom: 12px;"> Calculating total cost... </strong>
          <div id="loader" style="display: inline-block;" class="loader"></div>
          <strong id="erCost" style="margin-left: 4%; display: block; bottom: 12px;"></strong>
          <div v-if="doneLoading == true" class="m-l-4" style="border: 0.5px solid rgb(89, 149, 247); width: 90%; margin-bottom: 1%;" />
          <strong v-if="doneLoading == true" class="m-l-4" style="font-size: 14px;">Equipment Registration Fee Summary</strong>
          <div v-for="(item, index) in checkoutList">
            <div>
              <p class="checkout-item checkout-item-label">{{item.equipmentTypeCode}} ({{item.description}}):</p> <strong class="checkout-item-total-cost">${{item.inspectionFee + item.installationFee}}</strong>
            </div>
            <div>
              <p class="checkout-item-sub-label">Inspection Fee:</p> <strong class="checkout-item-sub-cost">${{item.inspectionFee}}</strong>
            </div>
            <div>
              <p class="checkout-item-sub-label">Installation Fee:</p> <strong class="checkout-item-sub-cost">${{item.installationFee}}</strong>
            </div>
            <div v-if="index == checkoutList.length - 1">
              <p class="checkout-item checkout-item-label-filing">Filing Fee:</p><strong class="checkout-item-filing-cost">${{filingFee}}</strong>
            </div>
          </div>
          <div class="m-l-4" style="border: 0.5px solid rgb(89, 149, 247); width: 90%; margin-top: 1%;" />
          <strong id="totalCost" style="margin-left: 4%; display: block; font-size: 26px; margin-top: 2%;"></strong>
        </div>
      </div>
      <div v-if="doneLoading == true">
        <p style="margin-top: 3%; font-size: 14px; max-width: 95%;">
          All Cook County Department of Environment and Sustainability Air division documents, including equipment registration permits and certificates of operation, will be sent electronically via email. A valid email address must be supplied in order to receive information regarding your application, including approved permits and certificates of operation.
        </p>
        <p style="margin-top: 1%; font-size: 14px;">
          Enter the email address to which all communications regarding application information should be addressed, and to which your documents should be sent.
        </p>
      </div>
      <div class="col-12 col-md-6" v-if="doneLoading == true" style="margin-top: 1%;">
        <!--(form.level2Option != null && form.level2Option != '')-->
        <label class="required"> Payer Email </label>
        <base-input v-model="form.payerEmail"
                    :validation="$v.form.payerEmail">
        </base-input>
      </div>
      <div class="col-12 col-md-6" v-if="doneLoading == true">
        <label class="required"> Verify Payer Email </label>
        <base-input v-model="form.payerEmailV"
                    :validation="$v.form.payerEmailV">
        </base-input>
      </div>
      <div v-if="needsPayment">
        <div class="col-12 col-md-12" style="margin-top: 2%; margin-left: -1%;">
          <button class="btn btn-success eDetailElement" @click="payWithCreditCard" id="withCard" disabled>
            Pay with <strong> Credit Card </strong>
          </button>
        </div>
        <div class="col-12 col-md-12" style="margin-left: -1%;">
          <button class="btn btn-success eDetailElement" @click="payWithAchCheck" id="withACH" disabled>
            Pay with <strong> ACH Check*</strong>
          </button>
          <p style="display: inline; font-size: 14px;">
            If your financial institution requires a Company ID, the NEW Company/Provider ID is 0000408976.
            <i>(The current COMPANY ID may still be used until the change takes place)</i>
          </p>
        </div>
      </div>
      <div v-else style="margin-top: 2%; margin-left: -1%;">
        <button class="btn btn-success eDetailElement" id="complete" @click="completeRegistration">
          <strong> Complete Registration </strong>
        </button>
      </div>
    </div>

    <form ref="lexisNexisForm" method="post" :action="lnLexisNexisPostUrl">
      <input type="hidden" name="ORDER_XML" v-model="orderXml" />
    </form>
  </div>
</template>

<script>
  import { submitChangeFee } from '~/js/FormFunctions'
  import { validateFiles } from '~/js/FormFunctions'
  import { getChangeFees } from '~/js/FormFunctions'
  import { getPayAchUrl } from '~/js/FormFunctions'
  import { completeRegistration } from '~/js/FormFunctions'
  import { getLexisNexisPaymentData } from '~/js/FormFunctions'
  import { errorNotification } from '~/js/FormFunctions'
  import { getPayAbility } from '~/js/FormFunctions'
  import BaseInput from '~/components/BaseInput'
  import { AirPaymentValidations } from '~/js/FormValidations'

  import moment from 'moment'

  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import { AirAddEquipmentForm } from '../../js/FormObjects';

  Vue.use(VueSweetalert2)

export default {
    name: 'ReviewSiteChanges',
    props: ['siteNumber'],
    components: { BaseInput },
    data() {
      return {
        changes: [],
        equipmentChanges: this.$parent.form.equipmentList,
        checkoutList: null,
        doneLoading: false,
        isValidNum: false,
        fetchingData: false,
        showModal: false,
        changeFee: null,
        totalCost: null,
        filingFee: null,
        erId: null,
        orderXml: null,
        lnLexisNexisPostUrl: null,
        form: this.$parent.form,
        needsPayment: true
      }
    },
    mounted() {
      this.form.payerEmail = null
      this.form.payerEmailV = null

      const vm = this

      var eFees = document.getElementsByClassName("eFee")
      var progressBars = document.getElementsByClassName("progress-bar")
      submitChangeFee(this.siteNumber, this.form.equipmentList, null)
        .then((data) => {
          var isComplete = false
          this.erId = data.equipmentRegistrationId
            getChangeFees(data.equipmentRegistrationId)
            .then((res) => {
              vm.totalCost = res.equipmentChangeFee.fee
              vm.filingFee = res.filingFee.fee

              vm.checkoutList = res.equipmentAdded

              document.getElementById("smbCost").style.bottom = "0"
              document.getElementById("smbCost").innerText = "Current Site Master Balance: $" + res.previousSiteMasterBalance.fee .toFixed(2)
              document.getElementById("erCost").innerText = "Equipment Registration Total: $" + res.equipmentChangeFee.fee.toFixed(2)
              document.getElementById("withCard").disabled = false
              document.getElementById("loader").style.display = "none"
              document.getElementById("withACH").disabled = false
              if (res.previousSiteMasterBalance.fee + res.equipmentChangeFee.fee <= 0) {
                vm.needsPayment = false;
                document.getElementById("totalCost").innerText = "Total Amount Due: $0.00"
              } else {
                document.getElementById("totalCost").innerText = "Total Amount Due: $" + (res.previousSiteMasterBalance.fee + res.equipmentChangeFee.fee).toFixed(2)
              }
              vm.doneLoading = true
            })
        }).catch((error) => {
            document.getElementById("loader").style.display = "none"
            document.getElementById("smbCost").style.bottom = "0"
            document.getElementById("smbCost").innerText = "No Pending Equipment Changes"
        })
    },
    validations: {
      form: new AirPaymentValidations()
    },
    methods: {
      calculateFee: function () {
        this.changeFee = 380
      },
      payWithCreditCard: function () {
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.$v.$touch()
            this.$notify('Error verifying payment email. Ensure that both emails match.', 'error')
            return
          }
          this.fetchingData = true
          validateFiles(this.form.fileRequestId)
              .then((res) => {
               getPayAbility(this.siteNumber)
              .then((res) => {
                  //this.$router.push({ name: 'AirThankYou', params: { erid: this.erId } })
                  const self = this
                  this.fetchingData = true
                  getLexisNexisPaymentData(this.siteNumber, this.erId, this.form.fileRequestId, this.form.payerEmail)
                      .then((data) => {
                          self.lnLexisNexisPostUrl = `https://${data.paymentUrlBase}/oobML/il/co/cook/DES/`

                          const orderXml = `<?xml version="1.0" encoding="utf-8"?>
                <multiLineFormPostRequest>
                <bypassReceiptUrl>${data.returnUrl}</bypassReceiptUrl>
                <lexisNexisCode>71527</lexisNexisCode>
                <paymentLineItems>
                <productLines>
                <productAmount>${data.totalFee}</productAmount>
                <lexisNexisProductCode>DES Online Payment</lexisNexisProductCode>
                <refField>${data.transactionId}</refField>
                <refField1>${data.sessionId}</refField1>
                </productLines>
                </paymentLineItems>
                </multiLineFormPostRequest>`
                          self.$set(self, 'orderXml', orderXml)

                          self.$nextTick(() => {
                              self.$refs.lexisNexisForm.submit()
                          })
                      })
                      .catch((error) => {
                          self.fetchingData = false
                          console.error(error)
                      })
              })
              .catch((error) => {
                  this.fetchingData = false
              })
              })
              .catch((error) => {
                this.$swal("Missing Site Map", "A Site Map file is required to complete the equipment registration", "question")
                this.fetchingData = false
                return
              })
        },
      payWithAchCheck: function () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.$v.$touch()
          this.$notify('Error verifying payment email. Ensure that both emails match.', 'error')
          return
        }
        this.fetchingData = true
        validateFiles(this.form.fileRequestId)
             .then((res) => {
              getPayAbility(this.siteNumber)
                .then((res) => {
                    getPayAchUrl(this.siteNumber, this.erId, this.form.fileRequestId, this.form.payerEmail)
                        .then((response) => {
                          window.location.href = response
                        })
                        .catch((error) => {
                          self.fetchingData = false
                          errorNotification('Error submitting payment to vendor for ach:', error)
                         })
                })
                .catch((error) => {
                    this.fetchingData = false
                })
              })
          .catch((error) => {
              this.$swal("Missing Site Map", "A Site Map file is required to complete the equipment registration", "question")
              this.fetchingData = false
          })
          //this.$router.push({ name: 'AirThankYou', params: { erid: this.erId } })
        },
      completeRegistration: function () {
        this.fetchingData = true
        validateFiles(this.form.fileRequestId)
             .then((res) => {
              getPayAbility(this.siteNumber)
                  .then((res) => {
                      completeRegistration(this.siteNumber, this.erId, this.form.fileRequestId, this.form.payerEmail)
                        .then((response) => {
                          this.$router.push({ name: 'AirThankYouNoFee', params: { erid: this.erId } })
                        })
                        .catch((error) => {
                          self.fetchingData = false
                          errorNotification('Error completing registration:', error)
                         })
                })
                .catch((error) => {
                    this.fetchingData = false
                })
              })
          .catch((error) => {
              this.$swal("Missing Site Map", "A Site Map file is required to complete the equipment registration", "question")
              this.fetchingData = false
          })
      }
    },
    computed: {
      changeFeeDescription: function () {
        if (this.changeFee) {
          return `$${this.changeFee}`
        } else {
          return 'Press button to calculate fee'
        }
      }
    }
}

</script>